import { render, staticRenderFns } from "./formPage.vue?vue&type=template&id=636b79ec&scoped=true"
import script from "./formPage.vue?vue&type=script&lang=js"
export * from "./formPage.vue?vue&type=script&lang=js"
import style0 from "./formPage.vue?vue&type=style&index=0&id=636b79ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636b79ec",
  null
  
)

export default component.exports